<template>
    <div class="settings-classes">
        <div class="classes">
            <div class="page-header">
                <div class="right" v-show="$page.props.p['members.payments.make']">
                    <v-btn @click="openClassesModal" color="primary" dark>
                        <v-icon small class="mr-2">mdi-plus</v-icon>
                        {{ $page.props.lang.addClass || "Add class" }}
                    </v-btn>
                </div>
            </div>
            <v-dialog
            v-model="classesModal" content-class="customs-modal classes-modal"
            max-width="500px">
                <v-card>
                    <div class="modal-header">
                        <h4 class="modal-headline">{{ $page.props.lang.addClass || "Add class" }}</h4>
                        <div class="tools">
                            <v-btn icon @click="classesModal = false"><v-icon>mdi-close</v-icon></v-btn>
                        </div>
                    </div>
                    <v-card-text>
                        <v-container>
                            <div class="fields">
                                <div class="grid">
                                    <p class="custom-label">{{ $page.props.lang.title || 'Title' }}</p>
                                    <v-text-field v-model="newClass.title"
                                    outlined dense
                                    :error-messages="responseErrors.title" @focus="responseErrors.title=''"></v-text-field>
                                    <p class="custom-label">{{ $page.props.lang.choose || "Choose appointment color" }}</p>
                                    <div class="colors">
                                        <template v-for="color in colors">
                                            <div @click="picked(color)" 
                                            :class="newClass.color===color ? 'is-selected' : ''" class="color" 
                                            :key="color" :style="{ background: color }">
                                            </div>
                                        </template>
                                        <p v-if="responseErrors.color" class="message-error" v-html="responseErrors.color[0]"></p>
                                    </div>
                                    <p class="custom-label">{{ $page.props.lang.duration || 'Duration' }}</p>
                                    <v-select 
                                    v-model="newClass.duration" :items="times" 
                                    dense outlined :hide-details="!responseErrors.trainer_id" 
                                    :error-messages="responseErrors.duration" @focus="responseErrors.duration=''">
                                    </v-select>

                                    <p class="custom-label mt-4">{{ $page.props.lang.memberLimit || 'Member limit' }}</p>
                                    <v-text-field v-model="newClass.member_limit"
                                    outlined dense type="number"
                                    :error-messages="responseErrors.member_limit" @focus="responseErrors.member_limit=''"></v-text-field>
                                   
                                    <p class="custom-label">{{ $page.props.lang.description || "Description" }}</p>
                                    <v-textarea v-model="newClass.description"
                                    outlined dense
                                    :error-messages="responseErrors.description" @focus="responseErrors.description=''"></v-textarea>

                                    <v-checkbox v-model="newClass.is_bookable"
                                    :label="$page.props.lang.isBookable || 'Is bookable'" 
                                    hide-details></v-checkbox>
                                    <v-checkbox v-model="newClass.is_session"
                                    :label="$page.props.lang.isSession || 'Use as individual class'" 
                                    hide-details></v-checkbox>
                                </div>
                            </div>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="regular" @click="classesModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                <v-btn @click="saveNewClass" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                            </v-card-actions>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-dialog
            v-model="editClassesModal" content-class="customs-modal classes-modal"
            max-width="500px">
                <v-card>
                    <div class="modal-header">
                        <h4 class="modal-headline">{{ $page.props.lang.editClass || "Edit class" }}</h4>
                        <div class="tools">
                            <v-btn icon @click="editClassesModal = false"><v-icon>mdi-close</v-icon></v-btn>
                        </div>
                    </div>
                    <v-card-text>
                        <v-container>
                            <div class="fields">
                                <div class="grid">
                                    <p class="custom-label">{{ $page.props.lang.title || 'Title' }}</p>
                                    <v-text-field v-model="currentClassData.title"
                                    outlined dense
                                    :error-messages="responseErrors.title" @focus="responseErrors.title=''"></v-text-field>
                                
                                    <p class="custom-label">{{ $page.props.lang.choose || "Choose appointment color" }}</p>
                                    <div class="colors">
                                        <template v-for="color in colors">
                                            <div @click="picked(color)" 
                                            :class="color===currentClassData.color ? 'is-selected' : ''" class="color" 
                                            :key="color" :style="{ background: color }">
                                            </div>
                                        </template>
                                        <p v-if="responseErrors.color" class="message-error" v-html="responseErrors.color[0]"></p>
                                    </div>
                            
                                    <p class="custom-label">{{ $page.props.lang.duration || 'Duration' }}</p>
                                    <v-select 
                                    v-model="currentClassData.duration" :items="times" 
                                    dense outlined :hide-details="!responseErrors.trainer_id" 
                                    :error-messages="responseErrors.duration" @focus="responseErrors.duration=''">
                                    </v-select>
                                
                                    <p class="custom-label mt-4">{{ $page.props.lang.memberLimit || 'Member limit' }}</p>
                                    <v-text-field v-model="currentClassData.member_limit"
                                    outlined dense type="number" disabled
                                    :error-messages="responseErrors.member_limit" @focus="responseErrors.member_limit=''"></v-text-field>
                            
                                    <p class="custom-label">{{ $page.props.lang.description || "Description" }}</p>
                                    <v-textarea v-model="currentClassData.description"
                                    outlined dense
                                    :error-messages="responseErrors.description" @focus="responseErrors.description=''"></v-textarea>
                            
                                    <v-checkbox v-model="currentClassData.is_bookable"
                                    :label="$page.props.lang.isBookable || 'Is bookable'" 
                                    hide-details></v-checkbox>
                    
                                    <v-checkbox v-model="currentClassData.is_session"
                                    :label="$page.props.lang.isSession || 'Use as individual class'" 
                                    hide-details></v-checkbox>  

                                    <v-checkbox v-model="currentClassData.book_without_membership"
                                        label="Omogući rezervaciju bez članstva" 
                                        hide-details></v-checkbox>

                                    <v-checkbox v-model="currentClassData.show_participants"
                                        label="Prikaži učesnike klijentima" 
                                        hide-details></v-checkbox>
                                    
                                    <div v-if="currentClassData.is_bookable">
                                        
                                    <p class="custom-label mt-4">Koliko sati pre rezervacije članovi više ne mogu otkazati svoju rezervaciju</p>
                                    <v-text-field v-model="currentClassData.cancelation_hours"
                                    outlined dense type="number"
                                    :error-messages="responseErrors.cancelation_hours" @focus="responseErrors.cancelation_hours=''"></v-text-field>
                                    
                                    <p class="custom-label mt-4">Koliko sati pre rezervacije članovi više ne mogu napraviti rezervaciju</p>
                                    <v-text-field v-model="currentClassData.close_reservations"
                                    outlined dense type="number"
                                    :error-messages="responseErrors.close_reservations" @focus="responseErrors.close_reservations=''"></v-text-field>

                                    <p class="custom-label mt-4">Koliko dana želite dopustiti članovima da naprave rezervaciju</p>
                                    <v-text-field v-model="currentClassData.future_reservation_days_limit"
                                    outlined dense type="number"
                                    :error-messages="responseErrors.future_reservation_days_limit" @focus="responseErrors.future_reservation_days_limit=''"></v-text-field>
                            
                                </div>
                                </div>
                            </div>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="regular" @click="editClassesModal = false">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                                <v-btn @click="editClass" color="primary">{{ $page.props.lang.edit || "Edit" }}</v-btn>
                            </v-card-actions>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-dialog>
            
            <div class="table-container">
                <v-data-table
                :headers="classesHeaders"
                :items="classes"
                :page.sync="tablePage"
                @page-count="tablePageCount = $event"
                item-key="item.id"
                mobile-breakpoint="0"
                :items-per-page="itemsPerPage"
                hide-default-footer>
                    <template v-slot:item.title="{ item }">
                        <div class="name">
                            <v-avatar size="28">
                                <div class="color-avatar" :style="{ backgroundColor: item.color }"></div>
                            </v-avatar>
                            {{ item.title }}
                        </div>
                    </template>
                    <template v-slot:item.duration="{ item }">
                        {{ item.duration }}
                    </template>
                    <template v-slot:item.member_limit="{ item }">
                        {{ item.member_limit }}
                    </template>
                    <template v-slot:item.is_bookable="{ item }">
                        {{ item.is_bookable===1 ? ($page.props.lang.yes || 'Yes') : ($page.props.lang.no || 'No') }}
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn  @click="openEditModal(item.id)" :id="'edit' + item.id" icon>
                            <v-icon>mdi-pencil</v-icon>
                            <v-tooltip :activator="'#edit'+ item.id" bottom open-delay="500">
                                <span>{{$page.props.lang.edit || "Edit"}}</span>
                            </v-tooltip>
                        </v-btn>
                        <v-btn v-if="item.is_archived===0 && item.count_of_appointments>0" @click="openShowArchiveModal(item)" :id="'archive' + item.id" class="archive-icon" icon>
                            <v-icon>mdi-archive-arrow-down-outline</v-icon>
                            <v-tooltip :activator="'#archive'+ item.id" bottom open-delay="500">
                                <span>{{$page.props.lang.archive || "Archive"}}</span>
                            </v-tooltip>
                        </v-btn>
                        <v-btn v-if="item.is_archived===1" @click="unArchiveCourse(item)" :id="'unarchive' + item.id" class="archive-icon" icon>
                            <v-icon>mdi-archive-arrow-up-outline</v-icon>
                            <v-tooltip :activator="'#unarchive'+ item.id" bottom open-delay="500">
                                <span>{{$page.props.lang.unarchive || "Unarchive"}}</span>
                            </v-tooltip>
                        </v-btn>
                        <v-btn v-if="item.is_archived===0 && item.count_of_appointments===0" @click="openDeleteClassModal(item)" :id="'delete' + item.id" class="delete-icon" icon>
                            <v-icon>mdi-trash-can-outline</v-icon>
                            <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                                <span>{{$page.props.lang.delete || "Delete"}}</span>
                            </v-tooltip>
                        </v-btn>
                    </template>
                </v-data-table>
            </div>
        </div>

        <ConfirmModal :open="showArchiveModal"
        @no="showArchiveModal = false" 
        @yes="archiveClass" 
        @close="showArchiveModal = false"
        :title="$page.props.lang.archiveClassConfirmTitle || 'Archive confirmation'"
        :description="$page.props.lang.archiveClassConfirmDesc || 'Are You sure You want to archive class?'">
        </ConfirmModal>

         <v-snackbars :objects.sync="messageObjects" top right>
            <template v-slot:action="{ close }">
                <v-btn text @click="close()" icon><v-icon>mdi-close</v-icon></v-btn>
            </template>
        </v-snackbars>

        <ConfirmDelete :open="deleteClassModal" @no="deleteClassModal = false" @yes="deleteClass"></ConfirmDelete>
    </div>
</template>

<script>
import AppLayout from '@/js/Layouts/AppLayout'
import SettingsLayout from '@/js/Layouts/SettingsLayout'
import ConfirmDelete from '@/js/Components/ConfirmDelete'
import ConfirmModal from '@/js/Components/ConfirmModal'
import EventBus from '@/js/eventbus'

export default {
    layout: (h, page) => {
      return h(AppLayout, [
        h(SettingsLayout, [page]),
      ])
    },
    metaInfo() {
        return {
            title: this.$page.props.lang.classes || "Classes"
        }
    },
    components: {
        ConfirmDelete,
        ConfirmModal
    },
    props: {
        lang: Object,
        classes: Array,
    },
    data(){
        return {
            newClass: {
                color: '',
                is_bookable: false,
                is_session: false,
                description: ''
            },

            currentClassData:{},

            classesHeaders: [
                {text: this.lang.title || 'Title', value: 'title', align: 'start'},
                {text: this.lang.duration || 'Duration', value: 'duration', align: 'center', sortable: false},
                {text: this.lang.memberLimit || 'Member limit', value: 'member_limit', align: 'center', sortable: false},
                {text: this.lang.isBookable || 'Is bookable', value: 'is_bookable', align: 'center', sortable: false},
                {text: this.lang.action || 'Action', value: 'action', align: 'end', sortable: false}
            ],
            colors: [
                '#4CAF50', //green
                '#2196F3', //blue
                '#9C27B0', //purple
                '#607D8B', //blue-grey
                '#FF5722', //deep-orange
                '#CDDC39', //lime
            ],
            tablePageCount: 0,
            itemsPerPage: -1,
            tablePage: 1,
            times: [
                {value: 15, text: '00:15'},
                {value: 30, text: '00:30'},
                {value: 45, text: '00:45'},
                {value: 60, text: '01:00'},
                {value: 75, text: '01:15'},
                {value: 90, text: '01:30'},
                {value: 105, text: '01:45'},
                {value: 120, text: '02:00'},
                {value: 135, text: '02:15'},
                {value: 150, text: '02:30'},
                {value: 165, text: '02:45'},
                {value: 180, text: '03:00'}
            ],
            classesModal: false,
            editClassesModal: false,
            deleteClassModal: false,
            classForDeleteId: null,
            showArchiveModal: false,
            classForArchiveId: null,
            responseErrors: {},
            messageObjects: [],
        }
    },
    methods: {
        openClassesModal() {
            this.newClass = {
                title: '',
                color: '',
                is_bookable: false,
                duration: null,
                member_limit: null,
                is_session: false,
                description: ''
            }
            this.classesModal = true
        },

        picked(color) {
            this.newClass.color = color
            this.currentClassData.color = color
            this.responseErrors.color = ''
        },
        saveNewClass() {
            this.responseErrors = {}
            axios.post('/backoffice/settings/saveCourse', this.newClass)
                .then(response => {
                    if (response.data.status==="OK") {
                        this.classesModal = false
                        this.$inertia.reload({only:['classes']})
                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                })
        },
        openEditModal(id){
           
           axios.get('/backoffice/settings/getCourse/' + id)
                .then(response => {
                    if(response.data.status === "OK"){
                        this.editClassesModal = true;
                        this.currentClassData = response.data.course; 
                        console.log(this.currentClassData)
                    }else{
                        alert("Server error.")
                    }
                })
        },

        editClass(){
            let coursePack = {
                id: this.currentClassData.id,
                title: this.currentClassData.title,
                color: this.currentClassData.color,
                duration: this.currentClassData.duration,
                member_limit: this.currentClassData.member_limit,
                is_bookable: this.currentClassData.is_bookable === null ? false : this.currentClassData.is_bookable,
                description: this.currentClassData.description,
                is_session: this.currentClassData.is_session === null ? false : this.currentClassData.is_session,
                cancelation_hours: this.currentClassData.cancelation_hours,
                close_reservations: this.currentClassData.close_reservations,
                future_reservation_days_limit: this.currentClassData.future_reservation_days_limit,
                book_without_membership: this.currentClassData.book_without_membership === null ? false : this.currentClassData.book_without_membership,
                show_participants: this.currentClassData.show_participants === null ? false : this.currentClassData.show_participants,
            };

            axios.post('/backoffice/settings/updateCourse', coursePack)
                .then(response => {
                    if(response.data.status==="OK") {
                        this.$inertia.reload({only:['classes']})
                        this.messageObjects.push({ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                      this.editClassesModal = false
                    }
                })
                .catch(error => {
                    this.messageObjects.push({ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                });
        },

        openDeleteClassModal(item) {
            this.deleteClassModal = true
            this.classForDeleteId = item.id
        },
        deleteClass() {
            axios.post('/backoffice/settings/deleteCourse', {id: this.classForDeleteId})
                .then(response => {
                    if (response.data.status==="OK") {
                        this.deleteClassModal = false
                        this.$inertia.reload({only:['classes']})
                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                })
        },
        openShowArchiveModal(item) {
            this.showArchiveModal = true
            this.classForArchiveId = item.id
        },
        archiveClass() {
            axios.post('/backoffice/settings/deleteCourse', {id: this.classForArchiveId})
                .then(response => {
                    if (response.data.status==="OK") {
                        this.showArchiveModal = false
                        this.$inertia.reload({only:['classes']})
                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                })
        },
        unArchiveCourse(item) {
            axios.post('/backoffice/settings/unArchiveCourse', {id: item.id})
                .then(response => {
                    if (response.data.status==="OK") {
                        this.deleteClassModal = false
                        this.$inertia.reload({only:['classes']})
                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                })

        }
    }
}
</script>